import axios from 'axios';
import { GET_ENCAISSEMENTS, GET_ENCAISSEMENTS_BY_USER, GET_ENCAISSEMENTS_FOR_COMMISSION, GET_REMAINING_ENCAISSEMENTS, GET_SPECIFIC_ENCAISSEMENT, ADD_ENCAISSEMENT, ADD_ENCAISSEMENTS_TO_VENTE, EDIT_ENCAISSEMENT, ENCAISSEMENTS_STATUT_PTF_BV, DELETE_ENCAISSEMENT, CLEAR_ENCAISSEMENTS, CLEAR_REMAINING_ENCAISSEMENTS, ENCAISSEMENTS_LOADING } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IEncaissement, IEncaissementLine, ISociete } from '../../types/interfaces';
import store from '../store';

export const getEncaissements = (duration: any, societeId: number | string, societeName: string, showAll: number, venteProject: number | undefined = undefined) => (dispatch: Function, getState: Function) => {
  // dispatch(setEncaissementsLoading());
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements', {...tokenConfig(getState), params: {duration, societeId, societeName, showAll, venteProject}})
    .then(res =>
      dispatch({
        type: GET_ENCAISSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getEncaissementsRecep = (duration: any, societeId: number | string, societeName: string, showAll: number, includeNextOnes: number) => (dispatch: Function, getState: Function) => {
  // dispatch(setEncaissementsLoading());
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements/recep', {...tokenConfig(getState), params: {duration, societeId, societeName, showAll, includeNextOnes}})
    .then(res =>
      dispatch({
        type: GET_ENCAISSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getEncaissementsVerse = (duration: any, societeId: number | string, societeName: string, showAll: number, includeNextOnes: number) => (dispatch: Function, getState: Function) => {
  // dispatch(setEncaissementsLoading());
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements/verse', {...tokenConfig(getState), params: {duration, societeId, societeName, showAll, includeNextOnes}})
    .then(res =>
      dispatch({
        type: GET_ENCAISSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getEncaissementsExcel = (rib: string) => (dispatch: Function, getState: Function) => {
  // dispatch(setEncaissementsLoading());
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements/excel', {...tokenConfig(getState), params: {rib}})
    .then(res =>
      dispatch({
        type: GET_ENCAISSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getEncaissementsByIdsPromise = async (ids: number[]) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/encaissements/byIds', {...tokenConfig(store.getState), params: {ids}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
    });
  });
};

export const getImpayesByUser = async (userId: number) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/encaissements/impayesByUser', {...tokenConfig(store.getState), params: {userId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      console.log("err getImpayesByUser", err)
      resolve(false);
    });
  });
};

export const getEncaissementsAnpvHistory = async () : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/encaissements/anpvHistory', {...tokenConfig(store.getState), params: {}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      console.log("err getEncaissementsAnpvHistory", err)
      resolve(false);
    });
  });
};

export const getEncaissementsDelayHistory = async () : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/encaissements/delayHistory', {...tokenConfig(store.getState), params: {}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      console.log("err getEncaissementsDelayHistory", err)
      resolve(false);
    });
  });
};

export const getEncaissementsByUser = (byCharge: number, duration: any, userIds: number[], includeNocharges: number, societeId: number | string, societeName: string, possibleProjets: ISociete[], titled: string, includeSigneNotaire: number, showAll: number) => (dispatch: Function, getState: Function) => {
  // dispatch(setEncaissementsLoading());
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements/byUser', {...tokenConfig(getState), params: {byCharge, duration, userIds, includeNocharges, societeId, societeName, possibleProjets, titled, includeSigneNotaire, showAll}})
    .then(res =>
      dispatch({
        type: GET_ENCAISSEMENTS_BY_USER,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getEncaissementsForCommission = async (duration: any, userIds: number[], societeId: number, societeName: string, possibleProjets: ISociete[], titled: string = "ALL") : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/encaissements/forCommission', {...tokenConfig(store.getState), params: {duration, userIds, societeId, societeName, possibleProjets, titled}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getEncaissementsForCommission", err)
    });
  });
};

export const getRemainingEncaissements = () => (dispatch: Function, getState: Function) => {
  // dispatch(setEncaissementsLoading());
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements/remaining', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_REMAINING_ENCAISSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getEncaissementsCompta = (duration: any, societeIds: number[] | "ALL", societeNames: string[] | "ALL", showAll: number, encFlag: string) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements/compta', {...tokenConfig(getState), params: {duration, societeIds, societeNames, showAll, encFlag}})
    .then(res =>
      dispatch({
        type: encFlag,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getEncaissementById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_ENCAISSEMENT,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const searchEncaissements = async (tranche: string, type: string, immeuble: string, num: string, etage: string) : Promise<IEncaissement[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/encaissements/search', {...tokenConfig(store.getState), params: {tranche, type, immeuble, num, etage}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err =>
      console.log("err searchEncaissements", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
  });
};

export const checkEncaissementUniqueness = async (REF_REGLEMENT: string) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/encaissements/checkUniqueness', {...tokenConfig(store.getState), params: {REF_REGLEMENT}})
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const getFtpCheck = async (file_name: string, isAbsolutePath: number = 0) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/encaissements/ftpCheck', {...tokenConfig(store.getState), params: {file_name, isAbsolutePath}})
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const getSummaryProjectBudgetEnc = () => (dispatch: Function, getState: Function) => {
  // dispatch(setEncaissementsLoading());
  dispatch({
    type: ENCAISSEMENTS_LOADING
  });
  axios
    .get('/api/encaissements/summaryProjectBudgetEnc', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_ENCAISSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const addEncaissement = (venteID: number, bienID: number, associationID: number | undefined, isAssociation: number, encaissements: IEncaissementLine[], recuFile: any, recuId: number, driveFileId: string, recu_image_counter: number, uploads: any[], projectId: number, projectName: string, comId: number | undefined, comName: string | undefined, userId: number | undefined, userName: string | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements', {venteID, bienID, associationID, isAssociation, encaissements, recuFile, recuId, driveFileId, recu_image_counter, uploads, projectId, projectName, comId, comName, userId, userName}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_ENCAISSEMENTS_TO_VENTE,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const editEncaissementAnpv = (id: number, nepasverser: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/editAnpv', {id, nepasverser}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editEncaissement = (id: number, MODE_REGL: string, REF_REGLEMENT: string, TIRE_PAR: string, DATE_PORTEFEUILLE: Date, DATE_REGLEMENT: Date, IDBANQUE: number, BANQUE: string, uploadR: any, uploadV: any, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/edit', {id, MODE_REGL, REF_REGLEMENT, TIRE_PAR, DATE_PORTEFEUILLE, DATE_REGLEMENT, IDBANQUE, BANQUE, uploadR, uploadV}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editEncaissementModeReg = (id: number, MODE_REGL: string, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/editModeReg', {id, MODE_REGL}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editEncVerseDelay = (id: number, date: Date, comment: string, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/editEncVerseDelay', {id, date, comment, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editEncaissementCommissionedTo = (id: number, comId: number, comName: string, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/editCommissionedTo', {id, comId, comName, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const turnEncaissementStatut = (encaissements: any[], projectName: string | undefined, bvId: number | undefined, bvName: string | undefined, userId: number | undefined, userName: string | undefined, encFlag: string, callback: Function, print: boolean) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/turnStatut', {encaissements, projectName, bvId, bvName, userId, userName, encFlag}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      })
      callback(res.data, print)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const setEncaissementEI = (encaisses: any[], impayes: any[], bvId: number | undefined, bvName: string | undefined, userId: number | undefined, userName: string | undefined, callback: Function, print: boolean) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/setEI', {encaisses, impayes, bvId, bvName, userId, userName}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      })
      callback(res.data, print)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const setManualPreEI = (encaisses: any[], impayes: any[], userId: number | undefined, userName: string | undefined, callback: Function, print: boolean) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/setManualPreEI', {encaisses, impayes, userId, userName}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      })
      callback(res.data, print)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const setPreStatut = (ids: number[], isImpaye: number, callback: Function, print: boolean) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/preStatut', {ids, isImpaye}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ENCAISSEMENT,
        payload: res.data
      })
      callback(res.data, print)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const replaceEncaissement = (newEncaissementsIds: number[], oldEncaissementsIds: number[], comment: string, userId: number | undefined, userName: string | undefined, upload: any, callback: Function, print: boolean) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/encaissements/replace', {newEncaissementsIds, oldEncaissementsIds, comment, userId, userName, upload}, tokenConfig(getState))
    .then(res => {
      // dispatch({
      //   type: EDIT_ENCAISSEMENT,
      //   payload: res.data
      // })
      callback(res.data, print)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
    // .post('/api/encaissements/replace', {newEncaissementsIds, oldEncaissementsIds, userId, userName}, tokenConfig(store.getState))
    // .then(res => 
    //   resolve(res.data)
    // )
    // .catch(err => {
    //   resolve(false);
    //   console.log("err replaceEncaissement", err)
    // });
  // });
};

export const editComEncaissementPromise = async (id: number, comId: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .post('/api/encaissements/editCom', {id,comId}, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err editComEncaissementPromise", err)
      });
  });
};

export const markPossibleDesist = async (ids: number[]) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .post('/api/encaissements/markPossibleDesist', {ids}, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err markPossibleDesist", err)
      });
  });
};

export const deleteEncaissement = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/encaissements/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_ENCAISSEMENT,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteEncaissementPromise = async (id: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .delete(`/api/encaissements/${id}`, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err deleteEncaissementPromise", err)
      });
  });
};

export const clearEncaissements = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_ENCAISSEMENTS
  })
};

export const clearRemainingEncaissements = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_REMAINING_ENCAISSEMENTS
  })
};